$(document).ready(function(){

    const swiper = new Swiper('.swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
    });

    var allButtons = document.querySelectorAll('a[class^=goToSlideBtn]');

    for (var i = 0; i < allButtons.length; i++) {
        allButtons[i].addEventListener('click', function() {

            var slideIndex = parseInt(this.getAttribute("data-slide-index"), 10);
            var swiperIndex = parseInt(this.getAttribute("data-swiper-index"), 10);

            // console.log(slideIndex);
            // console.log(swiperIndex);

            // Check if slideIndex is a valid number
            if (!isNaN(slideIndex)) {
              // Go to the specified slide
              swiper[swiperIndex].slideTo(slideIndex);
            }
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/scripts/parts/swiper.js
// module id = 18
// module chunks = 0